import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CookieConsent } from './CookieConsent';
import { Toaster } from 'sonner';

export const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col bg-brand-periwinkle">
            <Navbar />
            <main className="flex-1">
                {children}
            </main>
            <Footer />
            <CookieConsent />
            <Toaster position="bottom-right" richColors />
        </div>
    );
};
